import { useEffect, useState } from "react";
import { ArrowRight, AlertTriangle } from "lucide-react";
import { Checkbox } from "@/components/ui/checkbox";
import { NoticeContent } from "@/components/notice/NoticeContent";
import { api } from "@/lib/api";

export const useSignupNotice = () => {
  const [html, setHtml] = useState(null);
  useEffect(() => {
    api.get("/site/signup-notice").then((r) => setHtml(r.data.html || "")).catch(() => setHtml(""));
  }, []);
  return html;
};

export const NoticeStep = ({ html, onAccept }) => {
  const [ok, setOk] = useState(false);
  return (
    <div data-testid="signup-notice">
      <div className="flex items-center gap-3 rounded-md bg-[#FFF0F0] border border-[#FAD4D4] p-4 mb-6">
        <AlertTriangle className="w-6 h-6 text-[#E60000] shrink-0" />
        <h2 className="font-heading text-2xl font-extrabold tracking-tight" data-testid="signup-notice-title">Important Notice</h2>
      </div>
      <NoticeContent html={html} testId="signup-notice-content" />
      <div className="mt-8 pt-6 border-t border-[#E5E7EB] flex flex-col sm:flex-row sm:items-center gap-4">
        <label className="flex items-start gap-3 text-sm font-medium cursor-pointer sm:mr-auto">
          <Checkbox checked={ok} onCheckedChange={(v) => setOk(!!v)} className="mt-0.5" data-testid="signup-notice-confirm" />
          I have read and understood all the information above.
        </label>
        <div className="sm:w-64"><button type="button" disabled={!ok} onClick={onAccept} className="w-full h-11 rounded-md bg-[#E60000] hover:bg-[#CC0000] disabled:opacity-50 disabled:cursor-not-allowed text-white font-semibold inline-flex items-center justify-center gap-2 transition-colors" data-testid="signup-notice-continue">Continue <ArrowRight className="w-4 h-4" /></button></div>
      </div>
    </div>
  );
};
